(function () {
  var d = document;

  function initHeader() {
    var header = d.querySelector('[data-nv-header]');
    var burger = d.querySelector('[data-nv-burger]');
    if (!header || !burger || burger.dataset.nvInit) return;
    burger.dataset.nvInit = '1';
    function close() { header.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); }
    burger.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 990) close(); });
  }

  function initAnnounce() {
    d.querySelectorAll('[data-nv-announce]').forEach(function (el) {
      if (el.dataset.nvInit) return;
      el.dataset.nvInit = '1';
      var msgs = el.querySelectorAll('.nv-announce__msg');
      if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 5000);
    });
  }

  function initSort() {
    d.querySelectorAll('[data-nv-sort]').forEach(function (sel) {
      if (sel.dataset.nvInit) return;
      sel.dataset.nvInit = '1';
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  function initProduct(root) {
    if (root.dataset.nvInit) return;
    root.dataset.nvInit = '1';
    var dataEl = root.querySelector('[data-variants]');
    var form = root.querySelector('form[data-nv-product-form]');
    if (!dataEl || !form) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var price = root.querySelector('[data-price]');
    var compare = root.querySelector('[data-compare]');
    var btn = root.querySelector('[data-add]');
    var hint = root.querySelector('[data-hint]');
    var slides = root.querySelectorAll('.nv-gallery__slide');
    var thumbs = root.querySelectorAll('[data-thumb]');

    function showImage(id) {
      var found = false;
      slides.forEach(function (s) {
        var on = String(s.dataset.imageId) === String(id);
        if (on) found = true;
      });
      if (!found) return;
      slides.forEach(function (s) { s.classList.toggle('is-active', String(s.dataset.imageId) === String(id)); });
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t.dataset.thumb) === String(id) ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showImage(t.dataset.thumb); }); });

    function selected() {
      var sel = [];
      root.querySelectorAll('.nv-opt input:checked').forEach(function (r) {
        sel[parseInt(r.dataset.position, 10) - 1] = r.value;
      });
      return sel;
    }
    function find(sel) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }
    function update() {
      var v = find(selected());
      if (!v) {
        btn.disabled = true;
        btn.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      price.textContent = v.price;
      if (v.compare) { compare.textContent = v.compare; compare.hidden = false; } else { compare.hidden = true; }
      btn.disabled = !v.available;
      if (hint) hint.hidden = v.available;
      btn.textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSold;
      if (v.image) showImage(v.image);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('.nv-opt input').forEach(function (r) { r.addEventListener('change', update); });
  }

  function init() {
    initHeader();
    initAnnounce();
    initSort();
    d.querySelectorAll('[data-nv-product]').forEach(initProduct);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);
})();
